import { UnsavedChangesDialog } from '@mews-commander/ui';
import { FloatingPanel } from '@mews/b2b-ui';
import { LocalizedText, useDialog } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { Button } from '@optimus-web/core';
import { DetailedPlatformProfileResult } from '@mews-commander/data-access';
import { EditPlatformProfileForm } from './EditPlatformProfileForm';
import { useEditPlatformProfileForm } from './useEditPlatformProfileForm';

export interface EditPlatformProfileDialogProps {
    platformProfile: DetailedPlatformProfileResult;
    closeDialog: () => void;
}

export const EditPlatformProfileDialog: React.FC<EditPlatformProfileDialogProps> = ({
    platformProfile,
    closeDialog,
}) => {
    const { hasDirtyFields, renderFormContent, isSubmitting, submit } = useEditPlatformProfileForm({
        platformProfile,
        onClose: closeDialog,
    });
    const [unsavedChangesDialogProps, toggleUnsavedDialog] = useDialog();
    const handleClose = hasDirtyFields ? toggleUnsavedDialog : closeDialog;

    return (
        <>
            <FloatingPanel
                active
                onClose={handleClose}
                loading={isSubmitting}
                title={
                    <LocalizedText
                        textKey={TextKey.PlatformProfileEditTitle}
                        substitutes={{ name: platformProfile.fullName || '' }}
                    />
                }
                footer={{
                    primary: (
                        <Button onClick={submit} size="medium" variant="primary" disabled={isSubmitting} type="submit">
                            <LocalizedText textKey={TextKey.SaveChanges} />
                        </Button>
                    ),
                    secondary: (
                        <Button
                            onClick={handleClose}
                            size="medium"
                            variant="tertiary"
                            disabled={isSubmitting}
                            type="submit"
                        >
                            <LocalizedText textKey={TextKey.Cancel} />
                        </Button>
                    ),
                }}
            >
                {renderFormContent(<EditPlatformProfileForm />)}
            </FloatingPanel>
            <UnsavedChangesDialog
                active={unsavedChangesDialogProps.active}
                onCancel={toggleUnsavedDialog}
                onDiscardChanges={closeDialog}
            />
        </>
    );
};
